<template>
	<svg version="1.1" baseProfile="basic" id="Layer_1"
	 xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 340.5 310.9"
	 xml:space="preserve">
	<g>
		<g>
			<path class="st0" d="M97.2,310.9c-3.3-1.7-5.6-4.4-7.7-7.4c-4.8-6.8-9.9-13.4-14.7-20.2c-1.6-2.2-3-3-5.7-2
				c-13.5,4.5-13.6,4.4-18.6-9c-3.5-9.5-6.8-19.1-10.4-28.6c-1.1-2.9-0.8-4.2,2.2-5.7c8.8-4.3,14.5-11.4,17.5-20.8
				c1-3.2,0.1-4.5-3-5.3c-9.3-2.5-18.2-1.6-26.5,3.1c-2.7,1.5-4,1.6-5.9-1.1C17,203.5,9.5,193.4,2.1,183.1c-3.2-4.4-2.7-7.3,1.6-10.6
				c8.2-6.3,8.2-6.3,4.7-16.1C6,149.7,3.5,143,1.1,136.3c-2.1-6.1-1-8.4,5-10.6C46,111.1,85.8,96.6,125.6,82.2
				c3.9-1.4,7.1-3.6,10.3-5.9c33.8-24.5,67.7-49.1,101.5-73.6c1-0.7,2.5-1.1,2.7-2.6c1.7,0,3.3,0,5,0c6.8,6.3,11,14.5,16.7,21.6
				c0.7,0.9,1.5,1.8,2,2.8c2.4,5.3,5.8,5.7,11.1,3.5c9.1-3.9,10.3-3,13.7,6.4c3.9,10.8,7.6,21.6,11.8,32.3c1.3,3.3,0.6,4.3-2.4,5.9
				c-8.7,4.4-14.5,11.4-17.4,20.9c-0.9,2.8-0.1,3.8,2.5,4.6c9.4,2.8,18.4,2.5,27-2.6c2.8-1.7,4.3-1.7,6.4,1.2c7,10.1,14.4,20,21.6,30
				c3.7,5.2,3.3,7.9-1.8,11.7c-7.6,5.7-7.6,5.7-4.3,14.9c2.4,6.7,4.9,13.4,7.3,20.2c2.5,7.1,1.6,9.1-5.4,11.6
				c-40,14.6-79.9,29.2-119.9,43.7c-2.9,1-5.4,2.4-7.9,4.2c-33.9,24.7-67.8,49.4-101.7,74c-2,1.4-4.1,2.7-6.1,4
				C97.9,310.9,97.5,310.9,97.2,310.9z M314.9,144.9c-20.1-0.2-35.7-11.8-41.7-30.1c-5.3-16.3,1.1-35.1,15.9-45.9
				c2.6-1.9,2.9-3.3,1.8-6.1c-2.8-7.3-5.3-14.7-8.2-22c-3-7.6-1-7.3-9.1-4.4C216.8,57.1,160,77.7,103.1,98.4
				c-2.3,0.9-5.2,1.2-6.9,2.8c-2.4,2.3,0.9,4.7,1,7.2c0.2,2.6,0,4.8-2.8,5.6c-2.6,0.7-4.6-0.2-5.6-2.8c-0.4-1.1-1-2.1-1.3-3.2
				c-0.6-2.9-2-3.1-4.7-2.2c-23.9,8.8-47.8,17.5-71.7,26.1c-2.4,0.9-3,1.7-2.1,4.3c3.3,8.7,6.5,17.4,9.5,26.3c1,3,2.5,4,5.4,3.4
				c4.4-0.9,8.7-0.2,12.8,0.9c16.5,4.6,27.4,15.3,31,32c3.7,17.2-2.2,31.5-16.1,42.2c-2.8,2.2-3.1,4-1.9,7c3.1,7.9,6,15.9,8.6,23.9
				c1.2,3.8,2.7,4.4,6.4,3c22.9-8.5,45.9-16.9,68.9-25.1c3.7-1.3,5.1-2.8,3.1-6.6c-1.5-3.1-1.8-6.6,2.3-7.8c3.8-1.2,5.4,1.8,6.1,4.9
				c0.9,3.9,2.6,4.4,6.4,3c21.2-7.9,42.5-15.5,63.7-23.3c37.6-13.7,75.3-27.4,113-41c3.6-1.3,4-2.8,2.7-6.1
				c-2.9-7.1-5.5-14.3-7.9-21.5C321.6,146.6,319.9,143.1,314.9,144.9z M159.1,69.1c1.8-0.2,2.8-0.2,3.7-0.5
				c31.5-11.5,63-23,94.5-34.4c2.8-1,2.8-1.9,1.2-4.1c-4.2-5.6-8.6-11.1-12.2-17c-2.7-4.4-4.7-4.3-8.7-1.3
				C211.8,30.8,185.9,49.6,159.1,69.1z M80,277.4c5.5,7.6,10.7,14.5,15.6,21.6c2,3,3.3,2.4,5.7,0.7c24.8-18.2,49.7-36.2,74.6-54.4
				c1.1-0.8,2.7-1.3,3.1-4C145.8,253.4,113.2,265.3,80,277.4z M279.3,105c0.5,6.7,2.6,12.3,5.9,17.3c8.6,13,27.4,18.9,41.7,13.2
				c4.9-1.9,5.4-3.8,2.2-8.2c-5.1-7-10.2-14-15.1-21.1c-1.4-2-2.7-2.9-5.3-1.8C299.2,108.4,289.6,108.2,279.3,105z M46.9,202.7
				c2.8,0.4,5.6,0.7,8.4,1.1c6.5,1.1,6.5,1.2,4.7-5.5c-0.2-0.8-0.5-1.6-0.8-2.4c-7.5-19.6-26-26.8-45.6-21c-4.9,1.4-5.3,3.7-2.2,7.9
				c5.1,7,10.3,13.9,15.2,21c1.6,2.4,3,2.8,5.7,1.6C36.9,203.6,41.8,202.9,46.9,202.7z"/>
			<path class="st0" d="M175.8,203.7c-3.4-0.2-5.3-3.6-3.8-7.1c2-4.6,4.1-9.1,6.2-13.6c14.3-30.5,28.5-61.1,42.8-91.6
				c0.8-1.8,1.7-3.6,2.7-5.3c1.2-1.9,3-2.7,5.2-1.6c2.2,1,3.4,2.7,2.7,5.2c-0.4,1.3-0.9,2.5-1.5,3.7c-16.4,35.1-32.7,70.1-49.1,105.2
				C180,200.9,178.9,203.5,175.8,203.7z"/>
			<path class="st0" d="M256.1,158.5c0,12.7-10.8,23.4-23.2,23.2c-12.8-0.1-22.9-10.5-23-23.4c-0.1-12.7,10.6-23.4,23.2-23.2
				C245.7,135.2,256.2,145.8,256.1,158.5z M219,158.4c0,8,6.4,14.5,14.2,14.3c7.5-0.1,13.9-6.6,13.9-14.2c0-7.8-6.6-14.4-14.3-14.4
				C225.2,144.2,219,150.6,219,158.4z"/>
			<path class="st0" d="M170.1,152.2c-13,0-23.1-10.1-23.1-23c0-13,10.1-23.2,23-23.2c12.9,0,23.2,10.3,23.2,23.1
				C193.1,141.9,183,152.1,170.1,152.2z M169.8,143.1c8.1,0.1,14.3-6,14.4-14c0-7.7-6.1-14-13.8-14.1c-8-0.2-14.3,6-14.3,14.1
				C156,137,161.9,143,169.8,143.1z"/>
			<path class="st0" d="M122.7,178.6c-0.3,2.5-1.2,4.3-3.3,4.9c-2.2,0.6-4.1-0.4-5-2.3c-1.7-4.1-3.3-8.3-4.5-12.5c-0.7-2.4,0.8-4,3-5
				c2.1-0.9,3.8-0.1,4.7,1.5C120.1,169.4,121.4,174.2,122.7,178.6z"/>
			<path class="st0" d="M128.2,202.8c2.5,0.1,3.9,1.2,4.6,3c1.5,3.7,2.9,7.5,4.1,11.3c0.8,2.6-0.3,4.7-2.8,5.6
				c-2.4,0.9-4.5,0-5.4-2.2c-1.7-4-3.3-8-4.4-12.2C123.6,205.2,125.3,203.2,128.2,202.8z"/>
			<path class="st0" d="M108.2,138.2c0.1,3.3-0.9,4.8-2.8,5.5c-2.1,0.8-4.3,0.3-5.2-1.7c-1.9-4.2-3.5-8.6-4.8-13
				c-0.7-2.2,0.8-3.9,2.8-4.7c1.8-0.8,4-0.6,4.9,1.2C105.2,130,106.9,134.7,108.2,138.2z"/>
		</g>
	</g>
	</svg>
</template>
<script>
export default {
	name: 'couponSvg',
}
</script>

<style scoped>
/* eslint-disable */
.st0 {
	fill: var(--iconsColor1);
}
svg {
	width: 100%;
	height: 100%;
}
</style>